<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    v-if="app"
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >        
        <material-card
          color="blue"
          title="Summary"
        >
          <v-container>
            <v-layout row wrap align-center>
              <v-flex xs12 lg2>
                <v-icon :size="150" :color="app.status.state | toStatusColor">{{ app.status.state | toStatusIcon }}</v-icon>
              </v-flex>
              <v-flex xs12 lg10>
                <v-list>
                  <v-list-tile v-for="item in summary" :key="item.name">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.value }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{item.label}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </material-card>

        <material-card
          color="blue"
          title="Parameters"
        >
          <v-data-table
            hide-actions
            :headers="paramsHeaders"
            :items="Object.keys(app.parameters)"
            disable-initial-sort
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td class="text-xs-left">{{item}}</td>
              <td class="text-xs-left">{{app.parameters[item]}}</td>
            </template>          
          </v-data-table>
        </material-card>

        <material-card
          color="blue"
          title="Diagnostics"
        >
          <v-data-table
            hide-actions
            :headers="diagHeaders"
            :items="diagMessages"
            disable-initial-sort
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td class="text-xs-left">{{item}}</td>
            </template>          
          </v-data-table>
        </material-card>

      </v-flex>
    </v-layout>

    <!-- <dialog-confirm 
      v-model="showConfirmRemoveAppDialog" 
      title="Remove Application?" 
      :content="`Are you sure you want to remove the application '${(currentApp || '').name}'? All data associated with this instance will be deleted.`"
      :challenge="(currentApp || '').name"
      @confirm="removeApp(currentApp)"
    /> -->

  </v-container>
</template>

<script>
import store from '@/store'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import ConfirmDialog from '@/dialogs/ConfirmDialog'

export default {
  components: {
    'dialog-confirm' : ConfirmDialog,
  },
  
  data() {
    return {
      showConfirmRemoveAppDialog: false,
      paramsHeaders: [
        { text: 'Name', align: 'left', value: 'name', sortable: false },
        { text: 'Value', align: 'left', value: 'value', sortable: false },
      ],
      diagHeaders: [
        { text: 'Messages', align: 'left', value: 'message', sortable: false },
      ],
    }
  },

  computed: {
    ...mapGetters('atmos', [
      'atmosInitialized',
      'atmosSubscription',
      'atmosApps',
      'atmosAppsRefreshing'
    ]),

    app() {
      return this.atmosApps.find(i => i.id == this.$route.params.id);
    },

    summary() {
      return [
        { label: 'Name', value: this.app.name },
        { label: 'Type', value: this.app.type },
        { label: 'Version', value: this.app.version },
        { label: 'Created On', value: moment(this.app.createdOn).format('LLL') },
        { label: 'Expires On', value: this.app.expiresOn ? moment(this.app.expiresOn).format('LLL') : "N/A" },
      ]
    },

    diagMessages() {
      var messages = [];
      if (this.app.status.message) {
        messages.push(this.app.status.message);
      }
      return messages;
    }
  },

  filters: {
    toStatusIcon: function (value) {
      switch (value) {
        case 'Pending': return 'mdi-clock-outline'
        case 'Installing': return 'mdi-plus-circle-outline'
        case 'Upgrading': return 'mdi-update'
        case 'OK': return 'mdi-play-circle-outline'
        case 'Suspect': return 'mdi-alert-circle-outline'
        case 'Uninstalling': return 'mdi-minus-circle-outline'
      }
    },

    toStatusColor: function (value) {
      switch (value) {
        case 'Pending': return 'info'
        case 'Installing': return 'info'
        case 'Upgrading': return 'info'
        case 'OK': return 'success'
        case 'Suspect': return 'error'
        case 'Uninstalling': return 'info'
      }
    }
  },

  methods: {
    ...mapActions('atmos', [
      'atmosRefreshApps',
      'atmosRemoveApplication',
    ]),

    confirmRemoveApp(app) {
      this.showConfirmRemoveAppDialog = true;
    },

    async removeApp() {
      //await this.atmosRemoveApplication(this.currentApp.name);
    },

  }  

}
</script>
